<template>

    <main class="gmp-page gmp-page--no-newsletter">
        <CK_subpagehero />
        <CK_two_column_text />
        <CK_two_column_fullbleed />

    </main>

</template>


<script>
    import CK_subpagehero from "../../../components/content/enterprise/benefit/CK_subpagehero";
    import CK_two_column_text from "../../../components/content/enterprise/benefit/CK_two_column_text";
    import CK_two_column_fullbleed from "../../../components/content/enterprise/benefit/CK_two_column_fullbleed";


    export default {
        name: 'CK_Benefit',
        components:{
            CK_subpagehero,
            CK_two_column_text,
            CK_two_column_fullbleed,

        }

    }


</script>

<style>



</style>